import React, { useState, useEffect, useContext } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/css/customer/publicCustomerCss/EventBlogs/eventblogs.css";
import TravelGuideSkeleton from "../HotelPages/Travel/TravelGuideSkeleton";

const FoodBlog = () => {
const { baseUrl } = useContext(AppContext);
const [foods, setFoods]     = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError]     = useState(null);
const fetchFoodBlogs = () => {
    setLoading(true);
    setError(null);

    axios
      .get(`${baseUrl}/customer/food-blogs`)
      .then((res) => {
        setFoods(res.data.data || []);
        setLoading(false);
      })
      .catch(() => {
        setError("Could not load food stories. Please try again.");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchFoodBlogs();
  }, []);

  const getImageUrl = (path) => {
    if (!path) return "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=640&fit=crop";
    if (path.startsWith("http")) return path;
    return `${baseUrl.replace("/api", "")}/storage/${path}`;
  };

  const getInitials = (name = "") =>
    name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2) || "JJ";

  const SkeletonCard = () => (
    <div className="eb-skeleton-card">
      <div className="eb-skeleton-img" />
      <div className="eb-skeleton-body">
        <div className="eb-skeleton-line short" />
        <div className="eb-skeleton-line title" />
        <div className="eb-skeleton-line long" />
        <div className="eb-skeleton-line long" />
        <div className="eb-skeleton-line medium" />
      </div>
    </div>
  );

  return (
    <div className="eb-page">
      <header className="eb-hero">
        <div className="eb-hero-dots" />
        <div className="eb-hero-content">
          <span className="eb-hero-eyebrow">Northern Pakistan</span>
          <h1 className="eb-hero-title">Traditional Foods</h1>
          <p className="eb-hero-sub">
            From hand-crimped meat pies to slow-cooked mountain trout – discover
            the authentic flavours of Gilgit-Baltistan, Hunza, Skardu and Chitral.
          </p>
        </div>
        <div className="eb-hero-wave">
          <svg viewBox="0 0 1440 56" preserveAspectRatio="none">
            <path d="M0,28 C480,56 960,0 1440,28 L1440,56 L0,56 Z" fill="#f2f5f8" />
          </svg>
        </div>
      </header>

      <Container className="eb-list-container">
        {loading && (
  <>
    {[...Array(3)].map((_, index) => (
      <TravelGuideSkeleton
        key={index}
        imgLeft={index % 2 === 0}
      />
    ))}
  </>
)}

        {!loading && error && (
          <div className="eb-error">
            <div className="eb-error-icon">⚠️</div>
            <p>{error}</p>
            <button onClick={fetchFoodBlogs}>Retry</button>
          </div>
        )}

        {!loading && !error && foods.length === 0 && (
          <div className="eb-empty">
            <p>No food stories found.</p>
            <button onClick={fetchFoodBlogs}>Refresh</button>
          </div>
        )}

        {!loading &&
          !error &&
          foods.map((blog, index) => {
            const imgLeft    = index % 2 === 0;
            const authorName = blog.Jjsubadmin?.admname || "Journey Junction";
            const initials   = getInitials(authorName);

            const keywords = blog.meta_keywords
              ? blog.meta_keywords.split(",").slice(0, 4).map((k) => k.trim()).filter(Boolean)
              : [];

            return (
              <article
                key={blog.id}
                className={`eb-card ${imgLeft ? "eb-card--img-left" : "eb-card--img-right"}`}
              >
                {/* Image panel */}
                <div className="eb-card-img-wrap">
                  <img
                    src={getImageUrl(blog.published_image)}
                    alt={blog.post_title}
                    className="eb-card-img"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src =
                        "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=640&fit=crop";
                    }}
                  />
                  <div className="eb-img-gradient" />
                  <span className="eb-cat-badge">🍽️ Food</span>
                  {blog.meta_title && (
                    <div className="eb-img-location">
                      <span>📍 {blog.meta_title}</span>
                    </div>
                  )}
                </div>

                <div className="eb-card-detail">
                  <div>
                    <p className="eb-region-label">
                      {blog.meta_title || "Local Cuisine"}
                    </p>
                    <h2 className="eb-card-title">{blog.post_title}</h2>
                    <p className="eb-card-desc">{blog.post_content}</p>

                    {keywords.length > 0 && (
                      <div className="eb-highlights">
                        <p className="eb-highlights-label">Highlights</p>
                        <ul className="eb-highlights-list">
                          {keywords.map((kw, i) => (
                            <li key={i} className="eb-highlight-item">
                              <span className="eb-dot" />
                              {kw}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="eb-like-row">
                    <div className="eb-author-chip">
                      <div className="eb-author-avatar">{initials}</div>
                      <span className="eb-author-name">{authorName}</span>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
      </Container>
    </div>
  );
};

export default FoodBlog;